<template>
    <div>
        <div v-if="isViewMode">
            {{ contentValue.value }}
        </div>

        <div v-else-if="isEditMode">
            <input v-if="inputType === 'text'" type="text" v-model="contentData.value" class="form-control" />
            <textarea v-if="inputType === 'textarea'" v-model="contentData.value" class="form-control"></textarea>
        </div>

        <div v-else-if="isCreateMode">
            <input v-if="inputType === 'text'" type="text" v-on:input="handleInputChange" placeholder="Enter value" class="form-control" />
            <textarea v-if="inputType === 'textarea'" v-on:input="handleInputChange" placeholder="Enter value" class="form-control"></textarea>
        </div>
    </div>
</template>

<script>
  import ContentMixin from './ContentMixin';

  export default {
    name: "TextContent",
    mixins: [ContentMixin],

    methods: {
      handleInputChange(event) {
        this.$set(this.contentData, 'value', event.target.value)
      }
    },

    data: () => ({
      contentData: {
        value: null
      }
    }),

    computed: {
      inputType () {
        return this.getRenderOption('paragraph', false) ? 'textarea' : 'text';
      }
    }
  };
</script>

<style scoped>

</style>